<template>
    <AppTabLinks :links="list" />
</template>

<script>
    import AppTabLinks from '@/components/AppTabLinks';

    export default {
        components: {
            AppTabLinks,
        },

        data() {
            return {
                isAuthorized: false,
                list: [
                    {
                        title: 'Карточка',
                        url: `/assistants/${this.$route.params.id}/service/${this.$route.params.service_id}`,
                    },
                    {
                        title: 'Редактировать',
                        url: `/assistants/${this.$route.params.id}/service/${this.$route.params.service_id}/edit`,
                    },
                    {
                        title: 'Категории',
                        url: `/assistants/${this.$route.params.id}/service/${this.$route.params.service_id}/categories`,
                    },
                    {
                        title: 'Варианты',
                        url: `/assistants/${this.$route.params.id}/service/${this.$route.params.service_id}/options`,
                    },
                    {
                        title: 'Дополнительно',
                        url: `/assistants/${this.$route.params.id}/service/${this.$route.params.service_id}/extras`,
                    },
                ],
            };
        },
    };
</script>
